import { ImageType } from '@sh/types/ImageTypes';
import * as MetricFilterTypes from '@sh/types/MediaManager/MetricFilter';
import * as ResponseTypes from '@sh/types/MediaManager/Response';

export * as RequestTypes from '@sh/types/MediaManager/Request';

export {
  MetricFilterTypes,
  ResponseTypes
};

export enum Mode {
  ADS = 'ad',
  IMAGES = 'image',
  HEADLINES = 'headline',
}

export enum ActionType {
  EDIT = 'editAction',
  DELETE = 'deleteAction',
  CLONE = 'cloneAction',
}

export class AdSelectedForEdit {
  isImageSelected = false;
  isHeadlineSelected = false;
  areTagsSelected = false;
}

export class AdCard {
  id!: string;
  image?: ImageType;
  trafficSource?: ResponseTypes.TrafficSource;
  headline?: string;
  tags!: string[];
  metrics!: MetricDto[];
  usedOn!: number;
  isEditable!: boolean;
  selected!: boolean;
  selectedForEdit?: AdSelectedForEdit;
  constructor(isGeneralEdit = true) {
    this.image = {};
    this.headline = '';
    this.tags = [];

    if (isGeneralEdit) {
      this.selectedForEdit = new AdSelectedForEdit();
    }
  }
}

export interface MetricDto extends MetricFilterTypes.DropDown {
  value: number | string;
}

export enum errorFields {
  image = 'image',
  headline = 'headline',
  tags = 'tags',
  undefined = 'undefined',
}

export interface TableTagsContainer {
  tags: string[];
}

export interface TableParams {
  data: AdCard;
}

export interface AddTag {
  tag: Tag;
  addTag: Function;
}
export interface Tag {
  id?: string;
  text: string;
}

export interface TrafficSource {
  uniqueName: string;
  name: string;
}

export interface ActiveAd extends AdCard {
  campaignsList: ResponseTypes.CampaignData[];
  errorMessage: string;
  isCampaignListLoading: boolean;
}
